import { useEffect, useState } from "react";
import {
  LoginForm,
  SignupForm,
  ForgotPassword,
  ResetPassword,
} from "../components";
import { useLocation } from "react-router-dom";

const AuthPage = () => {
  const FORM_DISPLAY = {
    login: 1,
    signup: 2,
    forgot: 3,
    reset: 4,
  };
  const [displayComponent, setDisplayComponent] = useState(FORM_DISPLAY.login);
  const [token, setToken] = useState(null);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenParam = params.get("token");
    if (tokenParam) {
      setToken(tokenParam);
      setDisplayComponent(FORM_DISPLAY.reset);
    }
  }, []);

  return (
    <>
      <div
        aria-hidden="true"
        className="flex absolute -top-96 start-1/2 transform -translate-x-1/2 z-[-1] w-screen h-[150%] overflow-hidden overflow-y-visible justify-center"
      >
        <div className="bg-gradient-to-r from-amber-200/50 to-amber-100 blur-3xl w-[100rem] md:w-[44rem] h-[50rem] md:h-[60rem] lg:h-[66rem] rotate-[-60deg] transform -translate-x-[10rem]  /50  "></div>
        <div className="bg-gradient-to-tl from-amber-200/50 via-amber-100 to-purple-50 blur-3xl w-[100rem] md:w-[44rem] h-[50rem] md:h-[60rem] lg:h-[66rem] rounded-fulls origin-top-left -rotate-12 -translate-x-[15rem]  /70  /70  /70"></div>
      </div>

      <div className="mt-5">
        {displayComponent === FORM_DISPLAY.login && (
          <LoginForm
            setDisplayComponent={setDisplayComponent}
            formDisplay={FORM_DISPLAY}
          />
        )}
        {displayComponent === FORM_DISPLAY.signup && (
          <SignupForm
            setDisplayComponent={setDisplayComponent}
            formDisplay={FORM_DISPLAY}
          />
        )}
        {displayComponent === FORM_DISPLAY.forgot && (
          <ForgotPassword
            setDisplayComponent={setDisplayComponent}
            formDisplay={FORM_DISPLAY}
          />
        )}
        {displayComponent === FORM_DISPLAY.reset && token && (
          <ResetPassword
            token={token}
            setDisplayComponent={setDisplayComponent}
            formDisplay={FORM_DISPLAY}
          />
        )}
      </div>
    </>
  );
};

export default AuthPage;
